import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HuntrHero from '@/components/huntr/HuntrHero';
import HuntrHow from '@/components/huntr/HuntrHow';
import HuntrCompare from '@/components/huntr/HuntrCompare';
import HuntrPricing from '@/components/huntr/HuntrPricing';
import HuntrFaq from '@/components/huntr/HuntrFaq';
import HuntrTestimonials from '@/components/huntr/HuntrTestimonials';
import LeadForm from '@/components/LeadForm';
import CalendlySection from '@/components/CalendlySection';

const TITLE = 'Huntr | AI B2B Lead Generation Engine — Ahana Digital Agency';
const DESCRIPTION =
  'Huntr is Ahana Digital\'s AI-powered B2B prospecting and outbound engine. Guaranteed hot leads every working day, from $500/month — or your money back.';

export default function Huntr() {
  useEffect(() => {
    document.title = TITLE;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', DESCRIPTION);
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Navbar />
      <HuntrHero />
      <HuntrHow />
      <HuntrCompare />
      <HuntrTestimonials />
      <HuntrPricing />

      <section id="huntr-start" className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
        <div className="max-w-[1320px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Request Access</p>
            <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight leading-tight">
              Tell us who your buyer is. We will bring them to you.
            </h2>
            <p className="mt-5 text-white/55 font-light leading-relaxed max-w-lg">
              Huntr is onboarded in controlled cohorts so deliverability stays pristine. Send your
              details and a senior strategist will confirm capacity, scope your ICP and set your
              guaranteed daily volume.
            </p>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 lg:p-8">
            <LeadForm
              type="huntr"
              buttonLabel="Request Huntr Access"
              showAdSpend={false}
              showMessage
              redirectTo="/thank-you"
            />
          </div>
        </div>
      </section>

      <HuntrFaq />
      <CalendlySection />
      <Footer />
    </div>
  );
}